// Turns a <select multiple class="js-tag-select"> into a tag/chip picker -
// selected values show as removable chips inside a single bordered box
// (click anywhere in it to open a dropdown and add more) - a dependency-free
// stand-in for the jQuery Chosen widget (no jQuery in this app).
//
// The real <select> stays in the DOM (just visually hidden) and is kept in
// sync, so the form still submits exactly as before; with JS off, the plain
// multiselect listbox shows instead and still works.
//
// Only exists on freshly-rendered pages (the reports filter form), so it's
// set up on "turbolinks:load" (fires on the first load too), the same as
// toast.js.

function buildTagSelect(select) {
  if (select.dataset.tagSelectReady) return
  select.dataset.tagSelectReady = 'true'

  var placeholderText = select.dataset.placeholder || 'Select options…'

  var wrapper = document.createElement('div')
  wrapper.className = 'tag-select'

  var box = document.createElement('div')
  box.className = 'tag-select-box'
  box.tabIndex = 0

  var dropdown = document.createElement('div')
  dropdown.className = 'tag-select-dropdown'
  dropdown.hidden = true

  wrapper.appendChild(box)
  wrapper.appendChild(dropdown)

  select.parentNode.insertBefore(wrapper, select)
  select.hidden = true

  function closeDropdown() {
    dropdown.hidden = true
  }

  function toggleOption(option, selected) {
    option.selected = selected
    select.dispatchEvent(new Event('change'))
    render()
  }

  function renderChip(option) {
    var chip = document.createElement('span')
    chip.className = 'tag-select-chip'
    chip.textContent = option.textContent

    var remove = document.createElement('button')
    remove.type = 'button'
    remove.className = 'tag-select-chip-remove'
    remove.setAttribute('aria-label', 'Remove ' + option.textContent)
    remove.textContent = '×'
    remove.addEventListener('click', function (event) {
      event.stopPropagation()
      toggleOption(option, false)
    })

    chip.appendChild(remove)
    return chip
  }

  function renderOptionRow(option) {
    var row = document.createElement('button')
    row.type = 'button'
    row.className = 'tag-select-option'
    row.textContent = option.textContent
    row.addEventListener('click', function (event) {
      event.stopPropagation()
      toggleOption(option, true)
    })
    return row
  }

  function render() {
    var options = Array.prototype.slice.call(select.options)
    var selected = options.filter(function (option) { return option.selected })
    var unselected = options.filter(function (option) { return !option.selected })

    box.innerHTML = ''
    if (selected.length) {
      selected.forEach(function (option) { box.appendChild(renderChip(option)) })
    } else {
      var placeholder = document.createElement('span')
      placeholder.className = 'tag-select-placeholder'
      placeholder.textContent = placeholderText
      box.appendChild(placeholder)
    }

    dropdown.innerHTML = ''
    if (unselected.length) {
      unselected.forEach(function (option) { dropdown.appendChild(renderOptionRow(option)) })
    } else {
      var empty = document.createElement('span')
      empty.className = 'tag-select-empty'
      empty.textContent = 'All selected'
      dropdown.appendChild(empty)
    }
  }

  box.addEventListener('click', function () {
    dropdown.hidden = !dropdown.hidden
  })

  document.addEventListener('click', function (event) {
    if (!wrapper.contains(event.target)) closeDropdown()
  })

  render()
}

document.addEventListener('turbolinks:load', function () {
  document.querySelectorAll('select.js-tag-select').forEach(buildTagSelect)
})
